"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { iconButton } from './styles.js';
import { renderComponentOrElement } from '../utils/helpers/component.js';
import { handleButtonUnfocusMouseEvent } from '../Button/utils.js';
import { ThemeProvider } from 'styled-components';
import { useTheme } from '../utils/theming/useTheme.js';

var _excluded = ["color", "status", "disabled", "invert", "round", "size", "icon", "tag", "onMouseUp", "onMouseOut", "transparent"];
var IconButtonComponent = function IconButtonComponent(props, ref) {
  var colorProp = props.color,
    _props$status = props.status,
    status = _props$status === undefined ? 'primary' : _props$status,
    _props$disabled = props.disabled,
    disabled = _props$disabled === undefined ? false : _props$disabled,
    _props$invert = props.invert,
    invert = _props$invert === undefined ? false : _props$invert,
    _props$round = props.round,
    round = _props$round === undefined ? false : _props$round,
    _props$size = props.size,
    size = _props$size === undefined ? 40 : _props$size,
    icon = props.icon,
    _props$tag = props.tag,
    tag = _props$tag === undefined ? 'button' : _props$tag,
    onMouseUp = props.onMouseUp,
    onMouseOut = props.onMouseOut,
    _props$transparent = props.transparent,
    transparent = _props$transparent === undefined ? false : _props$transparent,
    rest = _objectWithoutProperties(props, _excluded);
  // Don't leave button in focused state after button was clicked
  var handleMouseUp = React.useMemo(function () {
    return handleButtonUnfocusMouseEvent(onMouseUp);
  }, [onMouseUp]);

  // Don't leave button in focused state if button click was canceled by dragging cursor outside button
  var handleMouseOut = React.useMemo(function () {
    return handleButtonUnfocusMouseEvent(onMouseOut);
  }, [onMouseOut]);
  var theme = useTheme();
  var buttonTheme = theme.button.web;
  var color = colorProp ? colorProp : transparent ? theme.colors.primary : buttonTheme.color;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(iconButton, _extends({
    ref: ref,
    "data-testid": "elemental-IconButton",
    type: "button"
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ,
    as: tag,
    onMouseUp: handleMouseUp,
    onMouseOut: handleMouseOut,
    $color: color,
    $status: status,
    disabled: disabled === true,
    $disabledColor: buttonTheme.disabledColor,
    "aria-disabled": Boolean(disabled) ? true : undefined,
    $disabledStyle: disabled === 'style-only',
    $invert: invert,
    $round: round,
    $size: size,
    $transparent: transparent
  }, rest), renderComponentOrElement(icon, {
    size: 24
  })));
};
var IconButton = /*#__PURE__*/React.forwardRef(IconButtonComponent);

export { IconButton };
